import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import { useAuth } from "../contexts/AuthContext";
import {
  LayoutDashboard,
  Activity,
  Brain,
  Target,
  Kanban,
  BookOpen,
  Users as UsersIcon,
  UserCog,
  LogOut,
} from "lucide-react";

const NAV = [
  { to: "/internal/dashboard",  label: "Dashboard",     icon: LayoutDashboard, roles: ["CEO", "Sales"] },
  { to: "/internal/operations", label: "Operations",    icon: Activity,        roles: ["CEO", "Sales", "Analyst"] },
  { to: "/internal/ai-ops",     label: "AI Ops",        icon: Brain,           roles: ["CEO", "Sales", "Analyst"] },
  { to: "/internal/prospects",  label: "Prospects",     icon: Target,          roles: ["CEO", "Sales", "Analyst"] },
  { to: "/internal/crm",        label: "CRM Pipeline",  icon: Kanban,          roles: ["CEO", "Sales"] },
  { to: "/internal/customers",  label: "Customers",     icon: UsersIcon,       roles: ["CEO", "Sales"] },
  { to: "/internal/knowledge",  label: "Knowledge",     icon: BookOpen,        roles: ["CEO", "Sales", "Analyst"] },
  { to: "/internal/team",       label: "Team",          icon: UserCog,         roles: ["CEO"] },
];

export default function InternalLayout() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const isActive = (p) => loc.pathname.startsWith(p);

  return (
    <div className="grain min-h-screen">
      <Navbar />
      <div className="max-w-[1600px] mx-auto grid lg:grid-cols-12 gap-px bg-[var(--border-soft)] min-h-[calc(100vh-56px)]">
        <aside className="lg:col-span-2 bg-[var(--bg-secondary)] p-5">
          <div className="tick-label text-sky-400 mb-4">/ Internal Ops</div>
          <nav className="space-y-1 mb-6">
            {NAV.filter((n) => n.roles.includes(user?.role)).map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`internal-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`flex items-center gap-2.5 px-3 py-2 text-[12px] tracking-wide transition-colors ${
                  isActive(n.to)
                    ? "bg-sky-500/15 text-sky-300 border-l-2 border-sky-500"
                    : "text-slate-400 hover:text-slate-100 border-l-2 border-transparent"
                }`}
              >
                <n.icon className="w-3.5 h-3.5" strokeWidth={1.8} />
                {n.label}
              </Link>
            ))}
          </nav>
          <div className="border-t border-[var(--border-soft)] pt-4">
            <div className="tick-label mb-1">Signed In</div>
            <div className="text-sm text-slate-100 font-mono truncate" data-testid="internal-user-email">{user?.email}</div>
            <div className="font-mono text-[10px] text-sky-400 uppercase tracking-widest mt-0.5" data-testid="internal-user-role">{user?.role}</div>
            <button
              onClick={logout}
              data-testid="internal-logout"
              className="mt-3 inline-flex items-center gap-2 text-[10px] text-slate-400 hover:text-rose-400 font-mono tracking-[0.2em] uppercase"
            >
              <LogOut className="w-3 h-3" /> Logout
            </button>
          </div>
        </aside>
        <main className="lg:col-span-10 bg-[var(--bg-primary)] p-6 sm:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
